import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingWebpToJpegConfig } from '@/data/landingConfig/landingWebpToJpegConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_WebpToJpeg } from './schemaObject';

interface Props {}
const WebpToJpegConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_WebpToJpeg} />
			<LandingTemplate
				data={landingWebpToJpegConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default WebpToJpegConverter;
